module.exports = __webpack_public_path__ + "65cdcb5e406bed47efeafe98d9477d1f.fbx";